<template>
  <vs-row class="flex w-auto mr-4" vs-align="center">
    <vs-checkbox v-for="checkbox in list" :key="`searchCB-${name}-${checkbox}`" :checked="check && check.indexOf(checkbox) >= 0" :vs-value="checkbox" @change="onChangeCheckbox(checkbox)">
      {{ checkbox }}
    </vs-checkbox>
  </vs-row>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";

export default {
  name: "SearchNavCheckbox",
  components: { DateSelector },
  props: {
    value: Array,
    list: Array,
    name: String,
    type: {
      type: String,
      default: "checkbox",
    },
  },
  watch: {
    value(value) {
      this.check = value;
    },
  },
  computed: {
    getCheck() {
      const query = this.$route.query;
      try {
        const data = query[`${this.name}[]`];
        if (typeof data === "string") {
          return [query[`${this.name}[]`]];
        } else if (typeof data === "object") {
          return query[`${this.name}[]`];
        }
      } catch (e) {}

      return [];
    },
  },
  data() {
    return {
      check: [],
    };
  },
  created() {
    this.check = this.getCheck;
    this.$emit("input", this.check);
  },
  methods: {
    onChangeCheckbox(value) {
      const _cc = JSON.parse(JSON.stringify(this.check));
      if(this.type === 'radio') {
        _cc.splice(0, _cc.length);
      }
      if (this.check.indexOf(value) > -1) {
        _cc.splice(this.check.indexOf(value), 1);
      } else {
        _cc.push(value);
      }
      this.check = _cc;
      this.$emit("input", this.check);
    },
  },
};
</script>

<style scoped>
.mobile {
  width: 100% !important;
}
.layout-mobile {
  display: grid !important;
  grid-template-columns: 70px 1fr;
  margin: 0 0 1rem 0 !important;
}
.small {
  width: 80px;
}

.normal {
  width: 130px;
}
</style>
